/**
 * Reads `document.cookie` on each call, so it sees the session cookie removed by another tab or by
 * its expiry. A `useCookie` ref only follows what the Cookie Store API reports.
 */
export const hasSessionCookie = (): boolean =>
    document.cookie.split(';').some(c => c.trim().startsWith('session_expiry='))
